export const MAIN_URL = process.env.REACT_APP_API_URL
export const MAIN_API = process.env.REACT_APP_API_URL;

/* ---------------------------- ALL Auth API ---------------------------- */

export const LOGIN_API = '/api/admin/login'
export const SIGNUP_API = '/api/admin/signup'
export const CHECKEMAILID_API = '/api/admin/checkemailid'
export const VERIFYLINK_API = '/api/admin/verifylink'
export const RESETPASSWORD_API = '/api/admin/resetpassword'
export const CHANGEPASSEORD_API = '/api/admin/changepassword'

/* ---------------------------- END Auth API ---------------------------- */

/* ---------------------------- ALL User API ---------------------------- */

export const GET_ALL_USER_API = '/api/admin/user/allusers'
export const GET_ALL_ADMIN_API = '/api/admin/user/alladmins'
export const UPDATE_USER_STATUS_API = '/api/admin/user/changestatus'
/* ---------------------------- END User API ---------------------------- */

/* ---------------------------- ALL Customer API ---------------------------- */

export const GET_ALL_CUSTOMER_API = '/api/admin/customer/allcustomers'
/* ---------------------------- END Customer API ---------------------------- */

/* ---------------------------- ALL State API ---------------------------- */

export const GET_ALL_STATE_API = '/api/state/allstates'
export const ADD_STATE_API = '/api/state/addstate'
export const UPDATE_STATE_API = '/api/state/updatestate'
/* ---------------------------- END State API ---------------------------- */

/* ---------------------------- ALL City API ---------------------------- */
export const GET_ALL_CITY_API = '/api/city/allcities'
export const ADD_CITY_API = '/api/city/addcity'
export const UPDATE_CITY_API = '/api/city/updatecity'
export const GET_CITY_BY_STATE_ID_API = '/api/city/getcitybystateid'
export const CHANGE_CITY_STATUS_API = '/api/city/updatecitystatus'
/* ---------------------------- END City API ---------------------------- */

/* ---------------------------- ALL Venue API ---------------------------- */
export const GET_ALL_VENUE_API = '/api/venue/allvenues'
export const ADD_VENUE_API = '/api/venue/addvenue'
export const UPDATE_VENUE_API = '/api/venue/updatevenue'
export const DELETE_VENUE_API = '/api/venue/deletevenue'
export const GET_VENUE_BY_CITY_ID_API = '/api/venue/getvenuebycityid'
/* ---------------------------- END Venue API ---------------------------- */

/* ---------------------------- ALL Category API ---------------------------- */
export const GET_ALL_CATEGORY_API = '/api/admin/category/allcategories'
export const ADD_CATEGORY_API = '/api/admin/category/addcategory'
export const UPDATE_CATEGORY_API = '/api/admin/category/updatecategory'
export const DELETE_CATEGORY_API = '/api/admin/category/deletecategory'
/* ---------------------------- END Category API ---------------------------- */

/* ---------------------------- ALL Event API ---------------------------- */
export const GET_ALL_EVENT_API = '/api/admin/event/allevents'
export const ADD_EVENT_API = '/api/admin/event/addevent'
export const UPDATE_EVENT_API = '/api/admin/event/updateevent'
export const DELETE_EVENT_API = '/api/admin/event/deleteevent'
export const GET_REVIEW_BY_EVENT_ID_API = '/api/admin/event/getreviewbyevent'
/* ---------------------------- END Event API ---------------------------- */

/* ---------------------------- ALL Event Day API ---------------------------- */
export const GET_ALL_EVENT_DAY_API = '/api/admin/day/allday'
export const ADD_EVENT_DAY_API = '/api/admin/day/addday'
export const UPDATE_EVENT_DAY_API = '/api/admin/day/updateday'
export const DELETE_EVENT_DAY_API = '/api/admin/day/deleteday'
export const GET_EVENT_DAY_BY_EVENT_ID_API = '/api/admin/day/getdaybyeventid'
/* ---------------------------- END Event Day API ---------------------------- */

/* ---------------------------- ALL Event Schedule API ---------------------------- */
export const GET_ALL_EVENT_SCHEDULE_API = '/api/admin/session/getshedule'
export const ADD_EVENT_SCHEDULE_API = '/api/admin/session/createshedule'
export const UPDATE_EVENT_SCHEDULE_API = '/api/admin/session/updateshedule'
export const DELETE_EVENT_SCHEDULE_API = '/api/admin/session/deleteshedule'
export const GET_EVENT_SCHEDULE_BY_DAY_ID_API = '/api/admin/session/getshedulebydayid'
/* ---------------------------- END Event Schedule API ---------------------------- */

/* ---------------------------- ALL Event Presenter API ---------------------------- */
export const GET_ALL_EVENT_PRESENTER_API = '/api/admin/presenter/allpresenters'
export const ADD_EVENT_PRESENTER_API = '/api/admin/presenter/addpresenter'
export const UPDATE_EVENT_PRESENTER_API = '/api/admin/presenter/updatepresenter'
export const DELETE_EVENT_PRESENTER_API = '/api/admin/presenter/deletepresenter'
export const GET_EVENT_PRESENTER_BY_SESSION_ID_API = '/api/admin/presenter/getpresenterbysessionid'
export const GET_EVENT_TICKET_API = '/api/admin/event/geteventticket'
/* ---------------------------- END Event Presenter API ---------------------------- */

/* ---------------------------- ALL App Settings API ---------------------------- */
export const GET_APP_SETTINGS_API = '/api/admin/appsetting/getappsetting'
export const UPDATE_APP_SETTINGS_API = '/api/admin/appsetting/updateappsetting'
export const GET_APP_SETTINGS_API_FAVICON = '/api/app/user/getappsetting'
/* ---------------------------- END App Settings API ---------------------------- */

/* ---------------------------- ALL Sponsor API ---------------------------- */
export const GET_ALL_SPONSOR_API = '/api/admin/sponsor/allsponsors'
export const ADD_SPONSOR_API = '/api/admin/sponsor/addsponsor'
export const UPDATE_SPONSOR_API = '/api/admin/sponsor/updatesponsor'
export const DELETE_SPONSOR_API = '/api/admin/sponsor/deletesponsor'
/* ---------------------------- END Sponsor API ---------------------------- */

/* ---------------------------- ALL Blog API ---------------------------- */
export const GET_ALL_BLOG_API = '/api/admin/blog/allblogs'
export const ADD_BLOG_API = '/api/admin/blog/createblog'
export const UPDATE_BLOG_API = '/api/admin/blog/updateblog'
export const DELETE_BLOG_API = '/api/admin/blog/deleteblog'
/* ---------------------------- END Blog API ---------------------------- */

/* ---------------------------- ALL Contact Us API ---------------------------- */
export const GET_ALL_CONTACT_US_API = '/api/admin/contectus/allcontectus'
/* ---------------------------- END Contact Us API ---------------------------- */

/* ---------------------------- ALL Cuponcode API ---------------------------- */
export const GET_ALL_CUPONCODE_API = '/api/admin/cuponcode/getallcuponcode'
export const ADD_CUPONCODE_API = '/api/admin/cuponcode/createcuponcode'
export const UPDATE_CUPONCODE_API = '/api/admin/cuponcode/updatecuponcode'

/* ---------------------------- END Cuponcode API ---------------------------- */

/* ---------------------------- ALL Order API ---------------------------- */
export const GET_ALL_ORDER_API = '/api/admin/order/getorders'
export const GET_INCOME_API = '/api/admin/order/income'
export const GET_ORDER_BY_ID_API = '/api/app/order/getorderbyid'
/* ---------------------------- END Order API ---------------------------- */

/* ---------------------------- ALL Dashboard API ---------------------------- */
export const GET_DAYWISE_INCOME_API = '/api/admin/dashbord/daywiseincome'
export const GET_LOGIN_STATS_API = '/api/admin/dashbord/loginstats'
export const GET_TOTAL_COUNT_API = '/api/admin/dashbord/totalcount'
/* ---------------------------- END Dashboard API ---------------------------- */

/* ---------------------------- ALL Theme API ---------------------------- */
export const GET_THEME_API = '/api/admin/adminTheme'
export const UPDATE_THEME_API = '/api/admin/theme/update'
/* ---------------------------- END Theme API ---------------------------- */

/* ---------------------------- ALL Event Sponsor API ---------------------------- */
export const GET_ALL_EVENT_SPONSOR_API = '/api/admin/eventsponsor/alleventsponsor'
export const ADD_EVENT_SPONSOR_API = '/api/admin/eventsponsor/addeventsponsor'
export const UPDATE_EVENT_SPONSOR_API = '/api/admin/eventsponsor/updateeventsponsor'
export const DELETE_EVENT_SPONSOR_API = '/api/admin/eventsponsor/deleteeventsponsor'
export const GET_EVENT_SPONSOR_BY_EVENT_ID_API = '/api/admin/eventsponsor/geteventsponsorbyeventid'
/* ---------------------------- END Event Sponsor API ---------------------------- */

/* ---------------------------- ALL Popup Image API ---------------------------- */
export const ADD_POPUP_IMAGE_API = '/api/admin/popupimage/addpopupimage'
export const GET_ALL_POPUP_IMAGE_API = '/api/admin/popupimage/getpopupimage'
export const UPDATE_POPUP_IMAGE_API = '/api/admin/popupimage/updatepopupimage'
/* ---------------------------- END Popup Image API ---------------------------- */


/* ---------------------------- ALL ROLES API ---------------------------- */
export const CREATE_ROLE = '/api/roles/create_roles'
export const GET_ALL_ROLE = '/api/roles/getroles'
export const UPDATE_ROLE_ID = '/api/roles/updaterolebyid'


/* ---------------------------- ALL SCREENS API ---------------------------- */
export const CREATE_SCREEN = '/api/screens/create_screen'
export const UPDATE_SCREEN = '/api/screens/update_screen/:id'
export const GET_ALL_SCREENS = '/api/screens/getallscreens'

/* ---------------------------- ALL auth API ---------------------------- */
export const REGISTER_API = "/api/app/user/register";
// export const VERIFY_EMAIL_API = "/api/app/user/verifyemail";
// export const LOGIN_API = "/api/app/user/login";


/* ---------------------------- Ticket Setup ---------------------------- */
export const GET_TICKET_TEMPLATE_BY_ID_API = '/api/admin/event/get_template_by_id'
export const CREATE_TICKET_CLASS_API = '/api/admin/event/createticketclass'


export const SAVE_TICKET_TEMPLATE_API = '/api/admin/event/save_ticket_template'
export const GET_TICKET_TEMPLATE_API = '/api/admin/event/get_ticket_templates'
export const DELETE_TICKET_TEMPLATE_API = '/api/admin/event/ticket-templates'
export const DUPLICATE_TICKET_TEMPLATE_API = '/api/admin/event/ticket-templates'



export const GET_CATEGORY_API = "/api/app/category/getcategory";
export const GET_CITY_API = "/api/app/city/getcity";
export const GET_COUNT_API = "/api/app/event/counts";
export const GET_FEATURED_EVENT_API = "/api/app/event/featuredevent";
export const GET_LATEST_BLOG_API = "/api/app/blog/getlatestblog";
export const GET_STATE_API = "/api/app/state/getstate";
export const GET_SPONSOR_API = "/api/app/sponser/getsponser";

/* ---------------------------- ALL Customer App Service API ---------------------------- */
export const GET_APP_SERVICE_META_API = '/api/admin/app-service/meta'
export const GET_ALL_APP_SERVICE_API = '/api/admin/app-service/list'
export const GET_APP_SERVICE_BY_ID_API = '/api/admin/app-service'
export const ADD_APP_SERVICE_API = '/api/admin/app-service/create'
export const UPDATE_APP_SERVICE_API = '/api/admin/app-service/update'
export const REORDER_APP_SERVICE_API = '/api/admin/app-service/reorder'
export const DELETE_APP_SERVICE_API = '/api/admin/app-service/delete'
export const UPLOAD_APP_SERVICE_ICON_API = '/api/admin/app-service/upload-icon'
/* ---------------------------- END Customer App Service API ---------------------------- */

/* ---------------------------- ALL Customer App Theme API ---------------------------- */
export const GET_APP_THEME_API = '/api/admin/app-theme'
export const UPDATE_APP_THEME_API = '/api/admin/app-theme/update'
export const RESET_APP_THEME_API = '/api/admin/app-theme/reset'
/* ---------------------------- END Customer App Theme API ---------------------------- */

/* ---------------------------- ALL Customer App Version API ---------------------------- */
export const GET_APP_VERSION_API = '/api/admin/app-version'
export const UPDATE_APP_VERSION_API = '/api/admin/app-version/update'
/* ---------------------------- END Customer App Version API ---------------------------- */

/* ---------------------------- ALL Advertisement/Campaign API ---------------------------- */
export const GET_ADVERTISEMENT_META_API = '/api/admin/advertisement/meta'
export const GET_ADVERTISEMENT_SUMMARY_API = '/api/admin/advertisement/summary'
export const GET_ALL_ADVERTISEMENT_API = '/api/admin/advertisement/list'
export const GET_ADVERTISEMENT_BY_ID_API = '/api/admin/advertisement'
export const ADD_ADVERTISEMENT_API = '/api/admin/advertisement/create'
export const UPDATE_ADVERTISEMENT_API = '/api/admin/advertisement/update'
export const DUPLICATE_ADVERTISEMENT_API = '/api/admin/advertisement/duplicate'
export const PUBLISH_ADVERTISEMENT_API = '/api/admin/advertisement/publish'
export const PAUSE_ADVERTISEMENT_API = '/api/admin/advertisement/pause'
export const RESUME_ADVERTISEMENT_API = '/api/admin/advertisement/resume'
export const ARCHIVE_ADVERTISEMENT_API = '/api/admin/advertisement/archive'
export const DELETE_ADVERTISEMENT_API = '/api/admin/advertisement/delete'
export const UPLOAD_ADVERTISEMENT_CREATIVE_API = '/api/admin/advertisement/upload-creative'
export const TEST_ADVERTISEMENT_TARGETING_API = '/api/admin/advertisement/test-targeting'
export const GET_ADVERTISEMENT_ANALYTICS_API = '/api/admin/advertisement/analytics/overview'
export const EXPORT_ADVERTISEMENT_ANALYTICS_API = '/api/admin/advertisement/analytics/export'
/* ---------------------------- END Advertisement/Campaign API ---------------------------- */
